import {DayNote} from '@app/core/models/day-note.model';
import {Moment} from 'moment';

export interface IDayNotesState {
	selectedDayNote: DayNote | null | undefined;
	createEditModelOpen: boolean;
	selectedDate: Moment | null | undefined;
	dayNotes: DayNote[];
	isLoading: boolean;
}

export const initialDayNotesState: IDayNotesState = {
	selectedDayNote: undefined,
	createEditModelOpen: false,
	selectedDate: undefined,
	dayNotes: [],
	isLoading: false,
};
